import { Component, OnInit } from '@angular/core'
import * as Chart from 'chart.js'
import { TransactionService } from '../services/transaction.service'
import { Analytics, SpendingDemographics, BiggestTransaction } from '../imports/server.models'
import { FormControl, FormGroup } from '@angular/forms'
import { AuthService } from '../services/auth.service'
import { Router } from '@angular/router'


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  canvas: any
  ctx: any
  message: string = ''
  response: any

  incomeTotal: number = 0
  expenseTotal: number = 0

  analytics: Analytics
  spendingDemographics: Array<SpendingDemographics> = []
  chartSelection: string = "spending"

  form = new FormGroup({
    selection: new FormControl('spending')
  })

  chartData: Array<number> = []
  chartLabels: Array<string> = []
  chartType: string = 'pie'
  chartColors: Array<any> = [{
    hoverBorderColor: ['rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.1)'],
    hoverBorderWidth: 0,
    backgroundColor: ["#F7464A", "#46BFBD", "#FDB45C", "#949FB1", "#4D5360"],
    hoverBackgroundColor: ["#FF5A5E", "#5AD3D1", "#FFC870", "#A8B3C5", "#616774"]
  }]

  constructor(private transactionService: TransactionService, public authService: AuthService, public router: Router) {
    this.analytics = new Analytics()
    this.spendingDemographics
  }

  ngOnInit(): void {
    this.getAnalytics()
  }

  get getSessionExpired() {
    if (!this.authService.isLoggedIn()) {
      return this.router.navigate(['/login'])
    }
  }

  ngAfterViewInit() {
    this.canvas = document.getElementById('pieChart')
    this.ctx = this.canvas.getContext('2d')
    const pieChart = new Chart(this.ctx, {
      type: 'pie',
      data: {
        labels: this.chartLabels,
        datasets: this.chartData,
        options:
        {
          legend:
          {
            display: false
          },
          responsive: true,
          display: true
        }
      }
    })
  }

  getAnalytics() {
    const today = new Date()
    const currentMonth = today.getMonth()
    const currentYear = today.getFullYear()

    this.transactionService.getTransactionAnalytics().subscribe(
      data => {
        console.log('Data', data)
        this.analytics.MostCommonTransactionType = data.mostCommonTransactionType
        this.analytics.BiggestTransactionByAmount = new BiggestTransaction(data.biggestTransaction.type, data.biggestTransaction.amountSpent)
        this.analytics.TransactionCount = data.transactionCount
        console.log("BiggestTrans", this.analytics.BiggestTransactionByAmount.Type)
        const transactionsInCurrentMonth = data.spendingDemographics ? data.spendingDemographics.reduce((acc, demographic) => {
          const transactionsInMonth = demographic.transactions.filter(transaction => {
            const transactionDate = new Date(transaction.date)
            return transactionDate.getMonth() === currentMonth && transactionDate.getFullYear() === currentYear
          })
          return [...acc, ...transactionsInMonth]
        }, []) : []
        // Get the amount spent on each transaction type
        const amountSpentByTransactionType = transactionsInCurrentMonth.reduce((acc, transaction) => {
          if (transaction.type in acc) {
            acc[transaction.type] += transaction.amount
          } else {
            acc[transaction.type] = transaction.amount
          }
          return acc
        }, {})

        const amountsByType = {}

        Object.entries(amountSpentByTransactionType).forEach(([type, amount]) => {
          const key = type[0].toUpperCase() + type.slice(1)
          amountsByType[key] = (amountsByType[key] || 0) + amount

          if (type.toLowerCase().includes('приход')) {
            this.incomeTotal += Number(amount)
          }

          if (type.toLowerCase().includes('разход')) {
            this.expenseTotal += Number(amount)
          }
        });

        const difference = this.incomeTotal - this.expenseTotal
        console.log('Income total:', this.incomeTotal)
        console.log('Expense total:', this.expenseTotal)
        console.log('Difference:', difference)

        this.analytics.savedAmount = difference

        // Find the type for which you have spent the most money
        let mostSpentTransactionType
        let mostSpentTransactionAmount = 0
        for (let type in amountsByType) {
          if (amountsByType[type] > mostSpentTransactionAmount) {
            mostSpentTransactionType = type
            mostSpentTransactionAmount = amountsByType[type]
          }
        }
        this.analytics.amountOfMostCommonTransactionType = mostSpentTransactionType
        this.analytics.TransactionCount = transactionsInCurrentMonth.length

        console.log("MostCommonTransactionType for current month:", this.analytics.MostCommonTransactionType)
        console.log("BiggestTransactionByAmount for current month:", this.analytics.BiggestTransactionByAmount.Type)
        console.log("Most spent transaction type:", this.analytics.amountOfMostCommonTransactionType)
        this.setSpendingDemographics(transactionsInCurrentMonth)
        this.setChartData(this.spendingDemographics)
      },
      err => {
        console.log(err)
      }
    )
  }

  setSpendingDemographics(data: Array<any>) {
    const transactionsByType = data.reduce((acc, transaction) => {
      const type = transaction.type.toLowerCase()
      const amount = transaction.amount

      if (!acc[type]) {
        acc[type] = {
          type: transaction.type,
          numberOfTransactions: 1,
          moneySpent: amount
        };
      } else {
        acc[type].numberOfTransactions++
        acc[type].moneySpent += amount
      }

      return acc
    }, {})

    const transactionsArray: any[] = Object.values(transactionsByType)

    for (var i = 0; i < transactionsArray.length; i++) {
      let demographic = new SpendingDemographics(transactionsArray[i].type, transactionsArray[i].numberOfTransactions, transactionsArray[i].moneySpent)
      this.spendingDemographics.push(demographic);
      this.analytics.Demographics.push(demographic);
    }
  }

  setChartData(data: Array<SpendingDemographics>) {

    this.resetChart()

    if (this.chartSelection === "spending") {
      this.setSpendingData(data)
    } else if (this.chartSelection === "transactions") {
      this.setTransactionData(data)
    }
    else {
      console.log('err')
    }

    console.log('chartData: ', this.chartData)
  }

  setSpendingData(data: Array<SpendingDemographics>) {
    for (var i = 0; i < data.length; i++) {

      let value = data[i].MoneySpent
      this.chartData.push(value)
      this.chartLabels.push(data[i].Type)
    }
  }

  setTransactionData(data: Array<SpendingDemographics>) {
    for (var i = 0; i < data.length; i++) {

      let value = data[i].NumberOfTransaction
      this.chartData.push(value)
      this.chartLabels.push(data[i].Type)
    }
  }

  changeSelection() {
    this.chartSelection = this.form.value.selection
    console.log("chartSlection: ", this.chartSelection)
    this.setChartData(this.spendingDemographics)
  }

  resetChart() {
    this.chartData = []
    this.chartLabels = []
  }
}
